import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Card,
  Divider,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { AuthContext } from "../../helper/context/auth/authContext";
import { userLoginAudit } from "../../helper/api/api";
import toast from "react-hot-toast";

const LoginHistoryDataGrid = () => {
  const { user } = useContext(AuthContext);
  const [rows, setRows] = useState([]);

  const columns = [
    { field: "id", headerAlign: "center", headerName: "ID", flex: 0.5, minWidth: 80 },
    { field: "Email", headerAlign: "center", headerName: "Email", flex: 1.5, minWidth: 250 },
    { field: "IP", headerAlign: "center", headerName: "IP Address", flex: 1, minWidth: 150 },
    {
      field: "LoginTime",
      headerAlign: "center",
      headerName: "Login Time",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const date = new Date(params.value);
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    { field: "wayOfLogin", headerAlign: "center", headerName: "Way of Login", flex: 1, minWidth: 180 },
    { field: "Actions", headerAlign: "center", headerName: "Actions", flex: 1, minWidth: 180 },
  ];

  useEffect(() => {
    userLoginAudit()
      .then((res) => {
        if (res?.data?.AuditLogs) {
          // ensure DataGrid has unique id field
          const formatted = res.data.AuditLogs.map((item, index) => ({
            id: item.id || index + 1,
            Email: item.Email,
            IP: item.IP,
            LoginTime: item.LoginTime,
            wayOfLogin: item.wayOfLogin,
            Actions: item.Actions,
          }));
          setRows(formatted);
        } else {
          toast.error("No login history found");
        }
      })
      .catch((err) => {
        console.error("Login history error:", err);
        toast.error("Failed to load login history");
      });
  }, [user]);

  return (
    <Box p={3} sx={{ borderRadius: 2 }}>
      <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
        <Box p={2}>
          <Typography variant="h6" fontWeight={600}>
            Login History
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[5, 10, 25]}
            initialState={{
              pagination: { paginationModel: { page: 0, pageSize: 10 } },
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            sx={{
              border: "none",
              "& .MuiDataGrid-columnHeaders": {
                bgcolor: "#f1f3f4",
                fontWeight: 600,
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
              },
            }}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default LoginHistoryDataGrid;
